import React from "react";

import { FileDraftIcon } from "assets";

import { TABLE_HEADERS } from "consts";

import { UTILITY_BILL_PAGE } from "../../route-consts";

const BASE_WARNING_MESSAGE = "Failed to extract";

export const WARNING_MESSAGES = {
  endDate: `${BASE_WARNING_MESSAGE} end date`,
  startDate: `${BASE_WARNING_MESSAGE} start date`,
  provider: `${BASE_WARNING_MESSAGE} utility provider`,
  type: `${BASE_WARNING_MESSAGE} utility type`,
  measuredValue: `${BASE_WARNING_MESSAGE} usage`,
  measuredUnit: `${BASE_WARNING_MESSAGE} unit`,
  amount: `${BASE_WARNING_MESSAGE} cost`,
  currency: `${BASE_WARNING_MESSAGE} currency`,
  collector: `${BASE_WARNING_MESSAGE} utility account information`,
  subtype: `${BASE_WARNING_MESSAGE} subtype`,
  traveledMiles: `${BASE_WARNING_MESSAGE} traveled miles`,
} as const;

export const UTILITY_BILL_FORM_VIEW = {
  ICON: <FileDraftIcon />,
  ABSOLUTE_PATH: UTILITY_BILL_PAGE.ABSOLUTE_PATH,
  PATH: "",
  TITLE: "Invoice data",
};

export const COLLECTOR_LABEL = `Utility type / ${TABLE_HEADERS.accountNumber} / ${TABLE_HEADERS.meterNumber}`;

export const sitePeriodBlockedMessage = "The bill is for a site and time period that's already signed off or locked. Including this bill may cause finalized emission numbers to change";

export const anomalyTypes = {
  BILL_DATE_RANGE: "Date Range",
  FUTURE_DATE: "Date Range",
  MULTIPLE_UPLOAD: "Duplicate_upload",
  PREVIOUS_USAGE_ZERO: "Previous usage zero",
  LAST_THRESHOLD_EXCEEDED: "Usage | MoM",
  Y2Y_THRESHOLD_EXCEEDED: "Usage | YoY",
  SITE_PERIOD_BLOCKED: "Site Period Blocked",
  COST: "Cost",
};

export const anomalyTypesKeys = Object.keys(anomalyTypes);
export const anomalyTypesValues = Object.values(anomalyTypes);
